export enum DirectionalityTypes {
  OUTBOUND = 'OUTBOUND',
  INBOUND = 'INBOUND',
  ROUNDTRIP_OUTBOUND = 'ROUNDTRIP_OUTBOUND',
  ROUNDTRIP_INBOUND = 'ROUNDTRIP_INBOUND',
}
